module.exports = __webpack_public_path__ + "static/media/006-pompom-green.bc0f3dec.svg";